/* eslint-disable no-undef */

import React from 'react';
import TagManager from 'react-gtm-module';

class GoogleTagManager extends React.Component {
  componentDidMount() {}

  isObject = val => {
    if (val === null) {
      return false;
    }
    return typeof val === 'function' || typeof val === 'object';
  };

  render() {
    if (
      !(
        !this.props.update &&
        this.isObject(this.props.additionalEvents) &&
        this.props.additionalEvents.event == 'NewVirtualPageview'
      )
    ) {
      const tagManagerArgs = {
        gtmId: this.props.gtmId,
        events: this.props.additionalEvents
      };

      TagManager.initialize(tagManagerArgs);
    }

    return <div></div>;
  }
}
export default GoogleTagManager;
